import { Component } from '@angular/core';

@Component({
  selector: 'app-authors',
  imports: [],
  templateUrl: './authors.component.html',
  styleUrl: './authors.component.scss'
})
export class AuthorsComponent {

}
